import { Trigger } from '@radix-ui/react-tabs'
import * as React from 'react'

import { styled } from '~/styled'

import { Text } from '../text/Text'

const StyledTabsTriggerHoverBackground = styled('div', {
  base: [
    'absolute',
    'inset-0',
    'h-[calc(100%+2px)]',
    'opacity-0',
    'bg-(--interactive-1)'
  ]
})

const StyledTabsTrigger = styled(Trigger, {
  base: [
    'bg-none',
    'cursor-pointer',
    'shrink-0',
    'p-4',
    'select-none',
    'border-b-2',
    'border-b-transparent',
    'relative',
    'data-[state=active]:border-current',
    'data-[state=active]:font-semibold',
    'data-[state=active]:text-(--interactive-1)',
    'data-[state=active]:tracking-[-0.005em]',
    'disabled:cursor-not-allowed',
    'disabled:opacity-30',
    'not-disabled:active:text-(--interactive-3)',
    'not-disabled:focus-visible:[&_div]:opacity-7',
    'not-disabled:focus-visible:outline-none',
    'not-disabled:focus-visible:relative',
    'not-disabled:focus-visible:shadow-[var(--color-primary-800)_0px_0px_0px_4px]',
    'not-disabled:focus-visible:shadow-[white_0px_0px_0px_2px]',
    'not-disabled:focus-visible:text-(--interactive-2)',
    'not-disabled:focus-visible:z-1',
    'not-disabled:hover:[&_div]:opacity-7',
    'not-disabled:hover:text-(--interactive-2)'
  ]
})

export const TabsTrigger = React.forwardRef<
  HTMLButtonElement,
  React.ComponentProps<typeof StyledTabsTrigger> & { value: string }
>(({ children, ...rest }, ref) => (
  <StyledTabsTrigger {...rest} ref={ref}>
    <Text size="sm" as="span">
      {children}
    </Text>
    <StyledTabsTriggerHoverBackground />
  </StyledTabsTrigger>
))

TabsTrigger.displayName = 'TabsTrigger'
